const API = process.env.REACT_APP_API_URL || '/api';

export async function notificationApi(path = '', method = 'GET', body) {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('Prijavite se za obavijesti.');
  const response = await fetch(`${API}/filter-notifications${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const error = new Error(data.error || 'Obavijesti trenutno nisu dostupne.');
    error.status = response.status;
    throw error;
  }
  return response.status === 204 ? null : response.json();
}

export async function notificationWorker() {
  if (window.jaosveNative) return window.jaosveNative.requestNotifications();
  const registration = await navigator.serviceWorker.register('/news-notifications-sw.js');
  if (registration.active) return registration;
  await new Promise((resolve, reject) => {
    const worker = registration.installing || registration.waiting;
    if (registration.active || worker?.state === 'activated') return resolve();
    if (!worker) return reject(new Error('Obavijesti nisu dostupne.'));
    worker.addEventListener('statechange', () => {
      if (worker.state === 'activated') resolve();
      if (worker.state === 'redundant') reject(new Error('Obavijesti nisu dostupne.'));
    });
  });
  return registration;
}

export const notificationsSupported = () => (
  Boolean(window.jaosveNative) || (window.isSecureContext && 'Notification' in window && 'serviceWorker' in navigator)
);

export async function pollNewsNotifications() {
  if (window.jaosveNative) return;
  if (!localStorage.getItem('token') || !notificationsSupported() || Notification.permission !== 'granted') return;
  const token = localStorage.getItem('token');
  const subscriptions = await notificationApi();
  let deliveryError;
  for (const subscription of subscriptions) {
    try {
      if (localStorage.getItem('token') !== token) return;
      const batch = await notificationApi(`/${subscription.id}/check`, 'POST');
      if (localStorage.getItem('token') !== token) return;
      if (!batch.batch) continue;
      const key = `news-notification-${subscription.id}`;
      if (localStorage.getItem(key) !== batch.batch) {
        const url = `${window.location.origin}/notifications/${subscription.id}/${encodeURIComponent(batch.batch)}`;
        const worker = await notificationWorker();
        if (localStorage.getItem('token') !== token) return;
        await worker.showNotification(`JaoSVE · ${subscription.name}`, {
          body: `${batch.count} novih vijesti\n\n${batch.articles.map(a => `• ${a.title}`).join('\n\n')}`,
          tag: `news-filter-${subscription.id}-${batch.batch}`, data: { url },
          requireInteraction: true,
          actions: [{ action: 'dismiss', title: 'Zatvori' }],
        });
        localStorage.setItem(key, batch.batch);
      }
      if (localStorage.getItem('token') !== token) return;
      await notificationApi(`/${subscription.id}/ack`, 'POST', { batch: batch.batch });
    } catch (error) {
      deliveryError = error;
    }
  }
  if (deliveryError) throw deliveryError;
}
